/** TTL кеша PictureDto (мм); текстуры меняются редко. */
export const COMPOSITION_TEXTURE_PICTURE_CACHE_TTL_MS = 24 * 60 * 60 * 1000;

const stores = {
    organization: new Map(),
    customer: new Map(),
};

const normalizePictureList = (payload) => {
    if (Array.isArray(payload)) {
        return payload;
    }
    if (payload != null && typeof payload === "object") {
        return Object.values(payload);
    }
    return [];
};

const getStore = (scope) => stores[scope] ?? stores.organization;

const isFresh = (entry, now) =>
    entry != null && now - entry.fetchedAt < COMPOSITION_TEXTURE_PICTURE_CACHE_TTL_MS;

export const getCachedTexturePictures = (scope, ids) => {
    const store = getStore(scope);
    const now = Date.now();
    const pictures = [];
    const missing = [];
    for (const id of ids) {
        const key = String(id);
        const entry = store.get(key);
        if (isFresh(entry, now) && entry.dto) {
            pictures.push(entry.dto);
        } else {
            missing.push(id);
        }
    }
    return {pictures, missing};
};

export const putCachedTexturePictures = (scope, list) => {
    const store = getStore(scope);
    const now = Date.now();
    for (const dto of normalizePictureList(list)) {
        if (dto?.id == null) {
            continue;
        }
        store.set(String(dto.id), {dto, fetchedAt: now});
    }
};

export const clearTexturePictureCache = (scope) => {
    if (scope) {
        getStore(scope).clear();
        return;
    }
    stores.organization.clear();
    stores.customer.clear();
};
